module.exports = __webpack_public_path__ + "img/feature_buy_th.8d5dfc38.png";